enum HttpMethod {
  GET = "get",
  POST = "post",
  PATCH = "patch",
  DELETE = "delete",
}

// https://github.com/Microsoft/TypeScript/issues/3320
export default HttpMethod;
